import { paymentSchema, type Payment } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const fetchPayment = (id: string, signal: AbortSignal): Promise<unknown> =>
  apiRequest<unknown>(`/payments/${id}`, { signal });

export const getPayment = async (id: string, signal: AbortSignal): Promise<Payment> =>
  paymentSchema.parse(await fetchPayment(id, signal));
